<div class="page-container">

  <div>
    @if (predefinedPlannedDateRange) {
      <div>
        Planned :
        @if (predefinedPlannedDateRange.start) {
          <span>
            {{predefinedPlannedDateRange.start | date:'yyyy-MM-dd HH:mm'}}
          </span>
        }
        <span> - </span>
        @if (predefinedPlannedDateRange.end) {
          <span>
            {{predefinedPlannedDateRange.end | date:'yyyy-MM-dd HH:mm'}}
          </span>
        }
      </div>
    }

    @if (predefinedFromRange) {
      <div>
        From :
        @if (predefinedFromRange.start) {
          <span>
            {{predefinedFromRange.start | date:'yyyy-MM-dd HH:mm'}}
          </span>
        }
        <span> - </span>
        @if (predefinedFromRange.end) {
          <span>
            {{predefinedFromRange.end | date:'yyyy-MM-dd HH:mm'}}
          </span>
        }
      </div>
    }

    @if (predefinedToRange) {
      <div>
        To :
        @if (predefinedToRange.start) {
          <span>
            {{predefinedToRange.start | date:'yyyy-MM-dd HH:mm'}}
          </span>
        }
        <span> - </span>
        @if (predefinedToRange.end) {
          <span>
            {{predefinedToRange.end | date:'yyyy-MM-dd HH:mm'}}
          </span>
        }
      </div>
    }
  </div>

  <!-- Results Section -->
  <div class="results-section">
    <mat-paginator #paginator [length]="totalData" [pageSizeOptions]="pageSizes" showFirstLastButtons
    [disabled]="isLoading"></mat-paginator>

    <div class="overflow-auto">
      <table mat-table matSort [dataSource]="dataSource" class="results-table mat-elevation-z2">
        <ng-container matColumnDef="orderNr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.ORDER_NR' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.orderNr }} </td>
        </ng-container>

        <ng-container matColumnDef="regNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.CARID' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.regNo }} </td>
        </ng-container>

        <ng-container matColumnDef="parkingName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PARKING_PRICING.PARKINGS' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.parkingName }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.NAME' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.name | translateAttribute }}</td>
        </ng-container>

        <ng-container matColumnDef="from">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FORM.PARKING_FROM' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.from | date:'yyyy-MM-dd HH:mm'}}</td>
        </ng-container>

        <ng-container matColumnDef="to">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FORM.PARKING_TO' | transloco }}</th>
          <td mat-cell *matCellDef="let order"> {{ order.to | date:'yyyy-MM-dd HH:mm'}}</td>
        </ng-container>

        <ng-container matColumnDef="planned">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ADDITIONAL_SERVICE_EDIT.PLANNED_DATE' | transloco }}
          </th>
          <td mat-cell *matCellDef="let order"> {{ order.planned | date:'yyyy-MM-dd' }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.STATUS' | transloco }}</th>
          <td mat-cell *matCellDef="let order">
            <app-status-badge [text]="order.status"
            [color]="getAdditionalServiceStatusColor(order.status)"></app-status-badge>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let order; columns: displayedColumns;" (click)="goToOrder(order.orderId)"
        class="clickable-row"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-data-content">
              <mat-icon>search_off</mat-icon>
              <span>{{ 'ORDER_LIST.NO_MATCH' | transloco }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
